/* eslint-disable prettier/prettier */
import css from "styled-jsx/css";

export const faqsCss = css`
  @function rem($size) {
    $remSize: calc($size / 16);
    @return #{$remSize}rem;
  }

  .faqs {
    padding: 2.5rem 1rem;
    :global(.faqs__title) {
      margin-bottom: 2.5rem;
    }
  }
`;
